import React from 'react';

const IconShare = ({ onClick }) => {
	return (
		<div className='IconShare' onClick={onClick}>
			<svg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<path d='M18 8C19.6569 8 21 6.65685 21 5C21 3.34315 19.6569 2 18 2C16.3431 2 15 3.34315 15 5C15 5.12548 15.0077 5.24917 15.0227 5.37061L8.08261 9.19367C7.54305 8.46796 6.6693 8 5.6875 8C4.06 8 2.75 9.34315 2.75 11C2.75 12.6569 4.06 14 5.6875 14C6.6693 14 7.54305 13.532 8.08261 12.8063L15.0227 16.6294C15.0077 16.7508 15 16.8745 15 17C15 18.6569 16.3431 20 18 20C19.6569 20 21 18.6569 21 17C21 15.3431 19.6569 14 18 14C17.0182 14 16.1445 14.468 15.605 15.1937L8.66486 11.3706C8.67988 11.2492 8.6875 11.1255 8.6875 11C8.6875 10.8745 8.67988 10.7508 8.66486 10.6294L15.605 6.80633C16.1445 7.53204 17.0182 8 18 8Z' fill='#667085' />
			</svg>
		</div>
	);
};

export default IconShare;
